/**
 * @file
 *
 * This file should load localization data.
 */

import 'air-datepicker/dist/js/i18n/datepicker.en'
